export var brandSymbolTheme = {
  baseStyle: {
    display: 'inline-flex',
    _readOnly: {
      opacity: '0.65'
    },
    _disabled: {
      opacity: '0.35'
    }
  }
};
//# sourceMappingURL=BrandSymbol.theme.js.map